<div *ngIf="!isInStandaloneMode">
    <!-- Android: Hiển thị nút "Install App" -->
    <button *ngIf="showInstallButton" class="btn btn-add-homescreen w-100 text-uppercase font-weight-bold" (click)="addToHomeScreen()">
        <i class="far fa-plus-square"></i>
        {{ 'UI.Common.AddHomescreen' | translate }}
    </button>
</div>